<!--
 - Author : wanghongling.
 - Date   : 2020/2/18.
 - File   : statistics.新版大数据统计
 -->

<template>
  <div class="statics-wrap">
    <!--导出总报表的按钮-->
    <div class="export-btn" @click="getMore(10)"><i class="el-icon-download"></i> 导出报表
    </div>
    <!--年份总览-->
    <div class="statis-block year-view">
      <el-form class="select-range">
        <tree-select :treeData="treeData" :value="value" :clearable="false" @getValue="getSelectOrgId"></tree-select>
      </el-form>
      <div class="sel">
        <el-select class="new-select" v-model="year" placeholder="请选择" @change="changeYear">
          <el-option
              v-for="item in yearList"
              :key="item"
              :label="item + '年'"
              :value="item">
          </el-option>
        </el-select>
        <span class="ex-span">年度总异常数</span>
        <span class="ex-count">
          <countTo :startVal="0" :endVal="ycObj.exceptionTotal" separator="">{{ycObj.exceptionTotal || 0}}</countTo>
        </span>
      </div>
      <div class="disposal1">
        <span class="most-more" @click="getMore(1)">
          <i class="iconfont icon-gengduo"></i>
        </span>
        <div class="disposal1-item">
          <p>已处置</p>
          <p>
            <countTo :startVal="0" :endVal="ycObj.exceptionHandle" separator="" :duration="5000">{{ycObj.exceptionHandle || 0}}</countTo>
          </p>
        </div>
        <div class="disposal1-item">
          <p>未处置</p>
          <p>
            <countTo :startVal="0" :endVal="ycObj.exceptionNoHandle" separator="" :duration="5000">{{ycObj.exceptionNoHandle || 0}}</countTo>
          </p>
        </div>
        <div class="disposal1-item">
          <p>处置率</p>
          <p>{{ycObj.exceptionHandlePercentage || 0}}</p>
        </div>
      </div>
      <!--异常类型统计-->
    </div>
    <div class="statis-block device-yc">
      <p class="block-title">设备异常类型统计</p>
      <span class="most-more" @click="getMore(2)">
          <i class="iconfont icon-gengduo"></i>
        </span>
      <div class="yc-class">
        <div class="yc-class-ring" v-for="(ring, index) in ringList" :key="index">
          <my-ring :id="'ring'+Math.random()" :ringObj="ringObj" v-if="ringObjTag" :color="ringColorList[index]" :val="ring.exceptionNum"></my-ring>
          <div class="yc-class-ring-name">{{ring.exceptionName}}</div>
          <div class="yc-class-ring-diff">{{ring.exceptionAgo?'较去年':'无上年数据'}}
            <span :class="ring.exceptionAgo>0?'zheng-num':'fu-num'">
              <span v-if="ring.exceptionAgo>0">+</span>{{ring.exceptionAgo}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--监管设备统计-原耗能统计-->
    <div class="statis-block energy-count">
      <p class="block-title">食品农残检测不合格率排行榜</p>
      <!--<span class="most-more" @click="getMore(3)">-->
        <!--<i class="iconfont icon-gengduo"></i>-->
      <!--</span>-->
      <div v-if="radarList.data.length>0">
        <air-AQI :radarList="radarList" v-if="radarListTag" id="detectionRecordRank"></air-AQI>
      </div>
      <div class="no-the-data" style="height: 245px" v-if="radarList.data.length===0">
        <div>
          <i class="iconfont icon-web__zanwujilu dzi" style="font-size: 40px;margin-bottom: 5px"></i>
          <p>暂无排行</p>
        </div>
      </div>
    </div>
    <!--月度异常趋势统计-->
    <div class="statis-block distric1">
      <p class="block-title">月度异常趋势统计</p>
      <span class="most-more" @click="getMore(4)">
        <i class="iconfont icon-gengduo"></i>
      </span>
      <div v-if="monthHasData">
        <my-line :id="'line'+Math.random()" :lineList="monthFoodLineList" v-if="monthFoodLineListTag"></my-line>
      </div>
      <div class="no-the-data" style="height: 255px" v-if="!monthHasData">
        <div>
          <i class="iconfont icon-web__zanwujilu dzi" style="font-size: 50px;margin-bottom: 10px"></i>
          <p>暂无月度异常趋势</p>
        </div>
      </div>
    </div>
    <!--监管设备资源分布情况-->
    <div class="statis-block foodType2">
      <span class="most-more" @click="getMore(5)">
        <i class="iconfont icon-gengduo"></i>
      </span>
      <div style="flex: 1;position: relative;">
        <p class="block-title block-title2" v-if="typePieList.data&&typePieList.data.length>0">监管设备<br>资源分布情况</p>
        <div v-if="typePieList.data&&typePieList.data.length>0">
          <my-pie :id="'pie'+Math.random()" :pieList="typePieList" v-if="typePieListTag"></my-pie>
        </div>
      </div>
      <el-carousel :interval="500000" :indicator-position="typePieList.data1.length>1?'outside':'none'"
          :arrow="typePieList.data1.length>1?'hover':'never'" style="flex: 1.5;margin-bottom: -10px;">
        <ul>
          <el-carousel-item v-for="(item, index) in typePieList.data1" :key="index" class="legend-uls">
            <li v-for="(type, i) in item" :key="i">
              <div class="legend-uls-p">
                <p class="color-block2" :style="{background:typePieList.color[i]}"></p>
                <p class="legend-per2">{{type.per}}<span>%</span></p>
              </div>
              <p>
                <span class="legend-name2">{{type.name}}</span>
              </p>
            </li>
          </el-carousel-item>
        </ul>
      </el-carousel>
      <div class="no-the-data h280" v-if="typePieList.data1 && typePieList.data1.length===0">
        <div>
          <i class="iconfont icon-web__zanwujilu dzi" style="font-size: 50px;margin-bottom: 10px"></i>
          <p>暂无监管设备资源统计</p>
        </div>
      </div>
    </div>
    <!--异常食堂分布-->
    <div class="statis-block foodOutType" style="padding-top: 10px;padding-bottom: 0px;">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="异常食堂分布" name="dept"></el-tab-pane>
        <el-tab-pane label="异常承包商分布" name="contra"></el-tab-pane>
      </el-tabs>
      <span class="most-more" @click="getMore(activeName ==='dept' ? 6 : 11)">
        <i class="iconfont icon-gengduo"></i>
      </span>
      <div v-if="pieList.data&&pieList.data.length>0">
        <my-pie :id="'pie'+Math.random()" :pieList="pieList" v-if="pieListTag"></my-pie>
      </div>
      <div class="no-the-data" style="height: 255px" v-if="pieList.data&&pieList.data.length===0">
        <div>
          <i class="iconfont icon-web__zanwujilu dzi" style="font-size: 50px;margin-bottom: 10px"></i>
          <p>{{activeName ==='dept' ? '暂无异常食堂分布' : '暂无异常承包商分布'}}</p>
        </div>
      </div>
    </div>
    <!--全年耗电、耗水趋势-->
    <div class="statis-block eleWater">
      <div class="eleWater-item">
        <p class="block-title">全年耗电量趋势</p>
        <my-line :id="'line'+Math.random()" :lineList="LineList" v-if="LineListTag"></my-line>
      </div>
      <div class="eleWater-item">
        <p class="block-title">全年耗水量趋势</p>
        <my-line :id="'line'+Math.random()" :lineList="waterLineList" v-if="waterLineListTag"></my-line>
      </div>
    </div>
    <!--日巡查清单异常总计-->
    <div class="statis-block monthEc">
      <span class="most-more" @click="getMore(8)">
        <i class="iconfont icon-gengduo"></i>
      </span>
      <p class="block-title">日巡查清单异常总计</p>
      <div style="flex: 1;position: relative;">
        <!-- <p class="block-title block-title2" :style="{left:rXCPieList.data.length>8?'40%':'50%'}" -->
        <p class="block-title block-title2" v-if="rXCPieList.data&&rXCPieList.data.length>0" :style="{left:rXCPieList.data.length>1?'40%':'50%'}">
          总共<br>
          <span>{{rXCPieList.total}}</span>
        </p>
        <div v-if="rXCPieList.data&&rXCPieList.data.length>0">
          <my-pie :id="'pie'+Math.random()" :pieList="rXCPieList" v-if="rXCPieListTag"></my-pie>
        </div>
      </div>
      <div class="no-the-data" style="height: 250px" v-if="rXCPieList.data&&rXCPieList.data.length===0">
        <div>
          <i class="iconfont icon-web__zanwujilu dzi" style="font-size: 50px;margin-bottom: 10px"></i>
          <p>暂无日巡查清单异常</p>
        </div>
      </div>
    </div>
    <!--异常类别分布-->
    <div class="statis-block monthFood">
      <p class="block-title">异常类别分布</p>
      <span class="most-more" @click="getMore(9)">
        <i class="iconfont icon-gengduo"></i>
      </span>
      <div v-if="yclbPieList.data&&yclbPieList.data.length>0">
        <my-pie :id="'pie'+Math.random()" :pieList="yclbPieList" v-if="yclbPieListTag"></my-pie>
      </div>
      <div class="no-the-data" style="height: 255px" v-if="yclbPieList.data&&yclbPieList.data.length===0">
        <div>
          <i class="iconfont icon-web__zanwujilu dzi" style="font-size: 40px;margin-bottom: 5px"></i>
          <p>暂无异常类别分布</p>
        </div>
      </div>
    </div>
    <!--食堂资源统计-->
    <div class="statis-block sourceCount">
      <p class="block-title">员工画像</p>
      <div class="gender">
        <my-horizontal :horizontalObj="horizontalObj" v-if="horizontalObjTag"></my-horizontal>
        <div>
          <div class="gender-item">
            <liquid-fill id="nvFill" :liquid-list="safeFillData1" :showCicrle="false"></liquid-fill>
            <div style="margin-right: 20px;min-width: 30px;">
              <p>女性</p>
              <p>{{generalData.sexNum}}人</p>
              <p>{{generalData.sexPer*100}}%</p>
            </div>
          </div>
          <div class="gender-item">
            <liquid-fill id="nanFill" :liquid-list="safeFillData2" :showCicrle="false"></liquid-fill>
            <div style="margin-right: 20px;min-width: 30px;">
              <p>男性</p>
              <p>{{generalData.manNum}}人</p>
              <p>{{generalData.manPer*100}}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--各食堂异常统计弹窗-->
    <transition
        name="el-fade-in-linear">
      <exportData
          v-if="exportShow"
          :title="exportObj.title"
          :width="exportObj.width"
          :exportType="exportObj.exportType"
          :dateType="exportObj.dateType"
          :yearList="exportObj.yearList"
          :selectYear="this.year"
          :orgId="this.orgId"
          @closeEvent="closeYcPop">
      </exportData>
    </transition>
    <video v-if="play" class="video" src="../../static/video/diyishitang.ogg" muted autoplay loop>
    </video>
  </div>
</template>

<script>
  import TreeSelect from '../components/TreeSelect'
  export default {
    components: {
      TreeSelect
    },
    data () {
      return {
        activeName: 'dept',
        orgId: this.$store.getters.userInfo.orgId,
        treeData: [], // 树形结构数据
        value: '', // 数据来源默认选中的值
        year: new Date().getFullYear(),
        yearList: [],
        ycObj: {},
        yearWaterFlow: '0.0',
        sourceObj: {},
        play: true,
        exportShow: false, // 各报表弹窗
        exportIndex: null,
        exportObj: {
          title: '各食堂异常处置情况',
          width: '600px',
          dateType: 'daterange',
          exportType: 1,
          yearList: null
        }, // 各报表数据
        pieListTag: true, // 异常食堂分布实时刷新
        pieList: {
          name: '',
          width: '100%',
          margin: '0 auto',
          height: '255px',
          radius: ['0', '55%'],
          newLine: '\n',
          startAngle: 165,
          dw: '件',
          per: true,
          labelShow: true,
          color: ['#d24150', '#f46b45', '#face37', '#91c240', '#45ecba', '#5fbfed', '#e785c2', '#087ebc'],
          data: []
        },
        typePieListTag: true, // 监管设备资源分布情况刷新
        typePieList: {
          name: '',
          width: '100%',
          margin: '0 auto',
          height: '280px',
          radius: ['65%', '85%'],
          newLine: '\n',
          startAngle: 95,
          dw: '件',
          legendShow: false,
          per: true,
          labelShow: false,
          // color: ['#00bf90', '#08fff0', '#009cff', '#086bff', '#4047d2', '#fbd900', '#60c10b', '#88fe1f'],
          color: ['#fb9a00', '#fbd900', '#60c10b', '#88fe1f', '#00bf90', '#08fff0', '#ddfffd', '#99d7ff', '#009cff',
            '#086bff', '#084eff', '#4047d2', '#fb9a00', '#fbd900', '#60c10b', '#88fe1f', '#00bf90', '#08fff0',
            '#ddfffd', '#99d7ff', '#009cff', '#086bff', '#084eff', '#4047d2'],
          data: [],
          data1: []
        },
        rXCPieListTag: true, // 日巡查清单异常统计
        rXCPieList: {
          name: '',
          width: '100%',
          margin: '-30px auto 0px',
          height: '283px',
          radius: ['35%', '50%'],
          newLine: '\n',
          startAngle: 90,
          dw: '件',
          legendType: 0,
          per: true,
          legendShow: true,
          labelShow: false,
          color: ['#0d90f8', '#f46b45', '#face37', '#91c240', '#45ecba', '#5fbfed', '#d24150', '#e785c2'],
          total: 0,
          data: []
        },
        showStaff: false,
        yclbPieListTag: true,
        yclbPieList: {
          name: '',
          width: '100%',
          margin: '-70px auto 0',
          height: '325px',
          radius: ['30%', '40%'],
          newLine: '\n',
          startAngle: 95,
          dw: '件',
          legendType: 1,
          per: true,
          labelShow: false,
          color: ['#18ffad', '#bd7eff', '#ef6c6c', '#0d90f8'],
          data: []
        },
        // 总共监管设置资源统计水波图
        radarListTag: true,
        radarList: {
          width: '330px', //宽度
          height: '243px', // 高度
          dw: '%',
          gridLeft: '-22%',
          data: [],
          titlename: [],
          myColor: ['#f85445', '#fd6c2c', '#ffae01', '#fed009', '#d0d740'] // 颜色
        },
        generalData: {
          sexNum: 0,
          sexPer: 0,
          manNum: 0,
          manPer: 0
        },
        safeFillData1: {
          date: 0.402,
          width: '80px',
          height: '84px',
          margin: '10px 23px',
          radius: '100%',
          bgColor: 'rgba(255,179,179,1)',
          borderColor: '#02536e',
          shadowColor: '#05575f',
          theTop: '65px',
          titleColor: '#00c0ff',
          labelFontSize: 28,
          otherColor: true,
          otherDate: '00',
          colorList: ['rgba(255,111,111,1)', 'rgba(255,111,111,1)', 'rgba(255,111,111,0.9)'],
          shape: 'path://M499.84 691.2v294.4c0 10.24-2.56 20.48-10.24 28.16-7.68 7.68-15.36 10.24-28.16 10.24-10.24 0-20.48-2.56-28.16-10.24-7.68-7.68-12.8-15.36-12.8-28.16V691.2H310.4l115.2-384H405.12c-12.8 43.52-23.04 79.36-30.72 104.96-7.68 28.16-15.36 53.76-23.04 79.36-7.68 25.6-12.8 40.96-15.36 46.08-5.12 15.36-15.36 23.04-33.28 23.04l-7.68-2.56C279.68 552.96 272 542.72 272 527.36c0-5.12 0-7.68 2.56-10.24 0-2.56 5.12-12.8 7.68-28.16 5.12-15.36 10.24-35.84 17.92-61.44 7.68-23.04 15.36-51.2 23.04-76.8 7.68-28.16 15.36-53.76 25.6-81.92 5.12-20.48 17.92-38.4 35.84-53.76 17.92-15.36 38.4-23.04 58.88-23.04H579.2c20.48 0 40.96 7.68 58.88 23.04 17.92 15.36 30.72 33.28 38.4 53.76 7.68 25.6 15.36 53.76 23.04 81.92 7.68 28.16 15.36 53.76 23.04 76.8 7.68 23.04 12.8 43.52 17.92 61.44 5.12 15.36 7.68 25.6 7.68 28.16l2.56 7.68c0 17.92-7.68 28.16-23.04 33.28l-7.68 2.56c-17.92 0-28.16-7.68-33.28-23.04 0-5.12-5.12-20.48-12.8-46.08s-15.36-51.2-23.04-79.36c-7.68-28.16-17.92-61.44-30.72-104.96h-20.48L707.2 691.2h-107.52v294.4c0 10.24-2.56 20.48-12.8 28.16-7.68 7.68-17.92 10.24-28.16 10.24-12.8 0-20.48-2.56-28.16-10.24-7.68-7.68-10.24-15.36-10.24-28.16V691.2h-20.48zM512.64 168.96c23.04 0 43.52-7.68 58.88-23.04 15.36-15.36 23.04-35.84 23.04-61.44 0-23.04-7.68-43.52-23.04-58.88-15.36-17.92-35.84-25.6-58.88-25.6-25.6 0-43.52 7.68-61.44 25.6-15.36 15.36-25.6 35.84-25.6 58.88 0 23.04 7.68 43.52 25.6 61.44 15.36 15.36 35.84 23.04 61.44 23.04z'
        },
        safeFillData2: {
          date: 0.59,
          width: '80px',
          height: '84px',
          margin: '10px 23px',
          radius: '100%',
          bgColor: '#00808b',
          borderColor: '#02536e',
          shadowColor: '#05575f',
          theTop: '65px',
          titleColor: '#00c0ff',
          labelFontSize: 28,
          otherColor: true,
          otherDate: '00',
          colorList: ['rgba(14,255,255,1)', 'rgba(14,255,255,1)', 'rgba(14,255,255,0.9)'],
          shape: 'path://M512.584639 219.893708c40.41173 0.258019 73.19961-32.274913 73.199609-72.557634 0-40.025725-32.78788-72.559681-73.199609-72.559681-40.473163 0-73.196538 32.533956-73.196538 72.559681 0 40.089206 32.723375 72.557634 73.196538 72.557634z m73.330666 16.396499H439.129058c-55.266258 0-91.39098 48.28336-91.390981 94.203594v220.945238c0 42.847553 60.780905 42.847553 60.780905 0V347.144224h11.782872v555.564273c0 59.179548 82.417649 57.316077 84.337434 0V582.569248h15.696162V902.96754c3.391108 60.650871 84.340506 54.817796 84.340506-0.258019V347.144224h9.800631v204.234406c0 42.837314 62.696594 42.837314 62.696594 0V330.433391c0.126962-45.72979-36.116531-94.143184-91.257876-94.143184z'
        },
        tmpMonthFood: this.monthFoodLineList,
        monthFoodLineListTag: true, // 食品出库月度趋势刷新
        monthFoodLineList: {
          year: this.year,
          position: 'bottom', // 折线图指示表停留的位置
          margin: '8px auto 0',
          height: '245px',
          yName: '件',
          boundaryGap: true,
          padding: [20, 4, 5, 2000],
          grid: {
            left: '5%',
            right: '5%',
            bottom: '15%',
            top: '15%'
          },
          toolTipFormatter: '01',
          lineWidth: 2,
          symbolSize: 4,
          opacity: 0,
          xData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          list: {
            name: [],
            showSymbol: false,
            lineColor: ['#d40b0f', '#00bdfb', '#a759fa', '#01f1ab', '#d8a607', '#086bff', '#60c10b', '#88fe1f'],
            data: []
          }
        },
        monthHasData: false,
        viewObj: JSON.parse(window.localStorage.getItem('viewObj')),
        timeNewData: null,
        timeNewData1: null,
        timeNewDataA: null,
        timeNewDataB: null,
        timeNewDataC: null,
        ringObjTag: true,
        ringObj: {
          width: '80px',
          height: '80px',
          total: 2004,
          barWidth: 5,
          margin: '0 auto'
        },
        ringList: [],
        ringColorList: ['#f84557', '#9c55fa', '#05914b', '#a6d151', '#45f8e5', '#f68c33'],
        LineListTag: true, // 全年耗电量趋势
        LineList: {
          year: this.year,
          position: 'bottom', // 折线图指示表停留的位置
          margin: '8px auto -10px',
          height: '245px',
          yName: 'kWh',
          splitLine: true,
          grid: {
            left: '5%',
            right: '8%',
            bottom: '15%',
            top: '15%'
          },
          toolTipFormatter: '02',
          padding: [0, 4, 5, 860],
          smooth: true,
          opacity: 1,//折线是否有阴影
          xData: [1,2,3,4,5,6,7,8,9,10,11,12],
          list: {
            name: [],
            showSymbol: [false],
            lineColor: ['#00e5f4', '#fff000'],
            areaColor: [{
              start: 'rgba(0, 229, 244, 0.2)',
              end: 'rgba(0, 229, 244, 0)'
            },{
              start: 'rgba(254, 240, 0, 0.2)',
              end: 'rgba(254, 240, 0, 0)'
            }],
            data: [
              // [30, 40, 12, 55, 22, 25, 30, 29, 32, 35, 24, 26],
              // [50, 60, 85, 75, 102, 90, 92, 86, 84, 75, 98, 96]
            ]
          }
        },
        tmpLineList: this.LineList,
        waterLineListTag: true, // 全年耗水趋势
        waterLineList: {
          year: this.year,
          position: 'bottom', // 折线图指示表停留的位置
          margin: '8px auto -10px',
          height: '245px',
          yName: 't',
          splitLine: true,
          grid: {
            left: '5%',
            right: '8%',
            bottom: '15%',
            top: '15%'
          },
          toolTipFormatter: '02',
          padding: [0, 4, 5, 900],
          smooth: true,
          opacity: 1,
          xData: [1,2,3,4,5,6,7,8,9,10,11,12],
          list: {
            name: [],
            showSymbol: [false],
            lineColor: ['#00e5f4', '#fff000'],
            areaColor: [{
              start: 'rgba(0, 229, 244, 0.3)',
              end: 'rgba(0, 229, 244, 0)'
            }, {
              start: 'rgba(254, 240, 0, 0.3)',
              end: 'rgba(254, 240, 0, 0)'
            }],
            data: [
              // [38, 80, 36, 38, 85, 65, 63, 59, 55, 57, 54, 60],
              // [20, 50, 12, 52, 33, 20, 50, 25, 30, 32, 48, 36]
            ]
          }
        },
        tmpWaterLineList: this.waterLineList,
        horizontalObjTag: true,
        horizontalObj: {
          width: '195px',
          height: '235px',
          nameList: [],
          data: [],
          barWidth: 12
        }
      }
    },
    destroyed () {
      this.destroyFnc()
    },
    deactivated () {
      this.destroyFnc()
    },
    async mounted () {
      this.orgId = this.$store.getters.userInfo.orgId
      if (!this.$route.meta.keepAlive) {
        await this.getYearList()
        this.init()
        this.dataFresh()
        this.play = true
      }
    },
    beforeRouteEnter (to, from, next) {
      next(() => {
        window.webSocket.onmessage = () => {
          // console.log('清除')
        }
      })
    },
    async activated () {
      this.orgId = this.$store.getters.userInfo.orgId
      await this.getYearList()
      this.viewObj = JSON.parse(window.localStorage.getItem('viewObj'))
      this.init()
      this.dataFresh()
      this.play = true
      this.exportShow = false
    },
    methods: {
      /**
       * 初始化
       * @author wanghongling
       * @createTime 2019/08/21
       */
      init () {
        this.getTreeList()//获取数据范围
        this.getRank() //获取设备类型故障排行
        this.getElectricConsume() //全年耗电量趋势
        this.getWaterConsume() //全年耗水量趋势
        this.getOnjobMemberPortrait()//获取员工画像数据
        this.getHandleInfo()
        this.getYearAndOrg()
        this.getTypeDeptGroup()
        this.getCountFoodInYear()
        this.getAnomalousTypeGroup()
        this.getCountFoodOutYearMonth()
      },
      /**
       * @Description:销毁事件
       * @author wanghongling
       * @createDate 2021/1/4
      */
      destroyFnc() {
        console.error('销毁事件')
        clearInterval(this.timeNewData)
        this.timeNewData = null
        clearTimeout(this.timeNewData1)
        this.timeNewData1 = null
        clearTimeout(this.timeNewDataA)
        this.timeNewDataA = null
        clearTimeout(this.timeNewDataB)
        this.timeNewDataB = null
        clearTimeout(this.timeNewDataC)
        this.timeNewDataC = null
        this.play = false
        this.exportShow = false
      },
      /**
       * @Description:获取员工画像数据
       * @author wanghongling
       * @createDate 2020/12/18
      */
      getOnjobMemberPortrait() {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        let name = []
        let data = []
        this.horizontalObjTag = false
        this.$request.onjobMemberPortraitGet(params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            name = res.ageList
            data = res.memberNum
            this.horizontalObj.nameList = name
            this.horizontalObj.data = data
            let total = res.manNum + res.sexNum
            res.manPer = total === 0 ? 0 : (res.manNum / total).toFixed(1)
            res.sexPer = total === 0 ? 0 : (res.sexNum / total).toFixed(1)
            this.safeFillData1.date = res.sexPer
            this.safeFillData2.date = res.manPer
            this.generalData = res
            // console.error(total)
          }
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          this.horizontalObjTag = true
        })
      },
      /**
       * @Description:获取全年耗电量趋势
       * @author wanghongling
       * @createDate 2020/12/16
      */
      getElectricConsume() {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.$request.electricConsumeGet(params).then(res => {
          let name = []
          let data = []
          if (!this.$utils.isEmptyObject(res)) {
            res.forEach(v => {
              name.push(v.year)
              data.push(v.valueList)
            })
            this.LineList.list.name = name
            this.LineList.list.data = data
            this.LineList.year = this.year
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:获取全年耗水量趋势
       * @author wanghongling
       * @createDate 2020/12/16
      */
      getWaterConsume() {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.$request.waterConsumeGet(params).then(res => {
          // console.error(res)
          let name = []
          let data = []
          if (!this.$utils.isEmptyObject(res)) {
            res.forEach(v => {
              name.push(v.year)
              data.push(v.valueList)
            })
            this.waterLineList.list.name = name
            this.waterLineList.list.data = data
            this.waterLineList.year = this.year
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:获取数据范围
       * @author wanghongling
       * @createDate 2020/12/14
      */
      getTreeList() {
        this.treeData = []
        this.$request.organizationOrgMemberConditionTreeListGet({}).then(res => {
          console.log('获取数据范围res：', res)
          this.treeData.push(res)
          this.value = this.orgId
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:点击数据范围获取所选组织
       * @author wanghongling
       * @createDate 2020/12/14
      */
      async getSelectOrgId(val) {
        console.log('点击数据范围获取所选组织:', val)
        if(val !== this.orgId) {
          this.orgId = await val
          this.init()
        }
      },
      /**
       * @Description:食品农残检测不合格率排名
       * @author wanghongling
       * @createDate 2020/12/14
      */
      getRank() {
        let params = {
          orgId: this.orgId,
          beginDate: this.year + '-01-01',
          endDate: this.year + '-12-31',
          pageSize: 5,
          result: '不合格'
        }
        this.radarListTag = false
        this.$request.detectionRecordRankGet(params).then(res => {
          this.radarList.data = res.map(v => v.percentage)
          this.radarList.titlename = res.map(v => v.sampleName)
          this.radarListTag = true
          console.log('食品农残检测不合格率排名', res, this.radarList)
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:获取各食堂处置信息
       * @author wanghongling
       * @createDate 2020/2/19
       */
      getMore (type) {
        this.exportShow = this.exportIndex === type ? !this.exportShow : true
        switch (type) {
          case 1:
            this.exportObj = {
              title: '各食堂异常处置情况',
              width: '500px',
              exportType: type
            }
            break
          case 2:
            this.exportObj = {
              title: '异常类型统计',
              width: '950px',
              exportType: type
            }
            break
          case 3:
            this.exportObj = {
              title: '监管设备统计',
              width: '810px',
              exportType: type
            }
            break
          case 4:
            this.exportObj = {
              title: '月度异常趋势统计',
              width: '800px',
              exportType: type,
              dateType: 'date',
              yearList: this.yearList
            }
            break
          case 5:
            this.exportObj = {
              title: '监管资源统计',
              width: '810px',
              exportType: type,
              dateType: 'date',
              yearList: this.yearList
            }
            break
          case 6:
            this.exportObj = {
              title: '异常食堂分布统计',
              width: '550px',
              exportType: type
            }
            break
          case 7:
            this.exportObj = {
              title: '人员分布情况统计',
              width: '400px',
              exportType: type,
              dateType: 'date',
              yearList: this.yearList
            }
            break
          case 8:
            this.exportObj = {
              title: '异常情况统计',
              width: '550px',
              exportType: type
            }
            break
          case 9:
            this.exportObj = {
              title: '异常类别分布统计',
              width: '515px',
              exportType: type,
              dateType: 'date',
              yearList: this.yearList
            }
            break
          case 10:
            this.exportObj = {
              title: '整体报表导出',
              width: '930px',
              dateType: 'date',
              exportType: type,
              yearList: this.yearList
            }
            break
          case 11:
            this.exportObj = {
              title: '异常承包商分布',
              width: '550px',
              exportType: type
            }
            break
          default:
            this.exportShow = false
            break
        }
        this.exportIndex = type
      },
      /**
       * @Description:关闭更多及导出弹窗
       * @author wanghongling
       * @createDate 2020/2/20
      */
      closeYcPop() {
        this.exportShow = false
      },
      /**
       * 切换选择年份
       * @author wanghongling
       * @createTime 2019/08/21
       * @param e 选中的值
       */
      async changeYear (e) {
        this.year = await e
        this.init()
      },
      /**
       * 获取统计年份列表
       * @author wanghongling
       * @createTime 2019/08/21
       */
      getYearList () {
        return this.$request.deptYearListGet({orgId: this.orgId}).then(res => {
          console.log('查看年份列表', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.yearList = res
            // this.yearList = ['2019', '2018', '2017']
            let tem = new Date().getFullYear().toString()
            if (JSON.stringify(this.yearList).indexOf(JSON.stringify(tem)) > -1) {
              this.year = tem
            } else {
              this.year = this.yearList[0]
            }
            console.log('params', this.year)
          } else {
            if (!this.year) {
              this.year = new Date().getFullYear()
              this.yearList.push(this.year)
            }
          }
        }).catch(e => {
          console.error(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 查看相应年份的异常统计
       * @author wanghongling
       * @createTime 2019/08/21
       */
      getHandleInfo () {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.ringList = []
        this.$request.pcExceptionYearCountGet(params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('查看相应年份的异常统计***', res)
            this.ycObj = res
            this.ringList = res.exceptionInfoList
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 根据组织ID和年份获取食堂资源统计信息
       * @author wanghongling
       * @createTime 2019/08/21
       */
      getYearAndOrg () {
        let params = {
          year: this.year,
          orgId: this.orgId
        }
        this.$request.canteenRourceYearandorgGet(params).then(res => {
          console.log('根据组织ID和年份获取食堂资源统计信息', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.sourceObj = res
            this.rXCPieList.total = res.inspectNoCheckCount
            this.rXCPieList.legendType = 0
            this.rXCPieList.piePos = null
            console.log('piePos' , this.rXCPieList.piePos)
            if(res.list.length > 8) {
              this.rXCPieList.legendType = 4
              this.rXCPieList.piePos = ['40%', '50%']
            }
            // this.rXCPieList.data = []
            this.rXCPieList.data.length = 0
            if (res) {
              this.rXCPieList.data = res.list.map(val => {
                return {value: val.deptNocheckCount, name: val.departmentName, per: val.deptNocheckPer}
              })
            }
          }
        }).catch(e => {
          console.error(e)
        })
      },
      handleClick(tab) {
        if(tab.name === 'dept'){
          this.getTypeDeptGroup()
        }else{
          this.getTypeContraGroup()
        }
      },
      /**
       * 异常食堂分布
       * @author wanghongling
       * @createTime 2019/08/21
       */
      getTypeDeptGroup () {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.$request.exceptionTypeDeptGroupGet(params).then(res => {
          console.log('异常食堂分布', res)
          // this.pieList.data = []
          this.pieList.data.length = 0
          if (!this.$utils.isEmptyObject(res)) {
            this.pieList.data = res.map(val => {
              return {value: val.total, name: val.departmentName}
            })
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 异常承包商分布
       * @author wanghongling
       * @createTime 2019/08/21
       */
       getTypeContraGroup () {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.$request.exceptionTypeContraGroupGet(params).then(res => {
          console.log('异常承包商分布', res)
          // this.pieList.data = []
          this.pieList.data.length = 0
          if (!this.$utils.isEmptyObject(res)) {
            this.pieList.data = res.map(val => {
              return {value: val.total, name: val.departmentName}
            })
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 异常类别分布
       * @author wanghongling
       * @createTime 2019/08/21
       */
      getAnomalousTypeGroup () {
        let params = {
          year: this.year,
          orgId: this.orgId
        }
        this.$request.exceptionNogoodtypeList(params).then(res => {
          console.log('异常类别分布', res)
          if (!this.$utils.isEmptyObject(res)) {
            res.forEach((v, i) => {
              switch (v.anomalousType) {
                case '01':
                  this.$set(res[i], 'anomalousTypeCn', '证件异常')
                  break
                case '02':
                  this.$set(res[i], 'anomalousTypeCn', '设备异常')
                  break
                case '03':
                  this.$set(res[i], 'anomalousTypeCn', '人员异常')
                  break
                // case '04':
                //   this.$set(res[i], 'anomalousTypeCn', '食品异常')
                //   break
                default:
                  break
              }
            })
            this.yclbPieList.data = res.map(val => {
              return {value: val.total, name: val.anomalousTypeCn, per: val.percent}
            })
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 根据组织ID获取监管设备资源分配信息
       * @author wanghongling
       * @createTime 2019/08/22
       */
      getCountFoodInYear () {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.$request.pcDeviceResourcePercentageGet(params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('根据组织ID获取监管设备资源分配信息', res)
            // this.typePieList.data = []
            this.typePieList.data.length = 0
            if (res) {
              this.typePieList.data = res.typeName.map((val, i) => {
                return {value: res.deviceNum[i], name: val, per: res.percentage[i]}
              })
              this.typePieList.data1.length = 0
              let tmpList = this.typePieList.data
              for (let i = 0; i < tmpList.length; i += 12) {
                this.typePieList.data1.push(tmpList.slice(i, i + 12))
              }
            }
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 获取月度趋势统计
       * @author wanghongling
       * @createTime 2019/08/22
       */
      getCountFoodOutYearMonth () {
        let params = {
          orgId: this.orgId,
          year: this.year
        }
        this.$request.pcExceptionMonthsTrendGet(params).then(res => {
          let name = []
          let data = []
          if (!this.$utils.isEmptyObject(res)) {
            this.monthHasData = true
            res.forEach(v => {
              name.push(v.exceptionName)
              data.push(v.months)
            })
            this.monthFoodLineList.list.name = name
            this.monthFoodLineList.list.data = data
            window.localStorage.setItem('ecList', JSON.stringify(data))
            this.monthFoodLineList.year = this.year
            this.tmpMonthFood = JSON.parse(JSON.stringify(this.monthFoodLineList))
            console.log('获取月度趋势统计', res, this.monthFoodLineList)
          } else {
            this.monthHasData = false
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:查看更多食堂人员分布情况
       * @author wanghongling
       * @createDate 2020/2/27
      */
      moreStaff() {
        this.showStaff = !this.showStaff
      },
      /**
       * echar组件 赋值
       * @author: zhzhy
       * @createDate: 2019/2/14
       * @return {Object}
       */
      valueUpdate () {
        let timestamp = 5000
        this.pieListTag = false
        this.monthFoodLineListTag = false
        this.ringObjTag = false
        this.$nextTick(() => {
          this.pieListTag = true
          this.monthFoodLineListTag = true
          this.ringObjTag = true
          this.monthFoodLineList = JSON.parse(JSON.stringify(this.tmpMonthFood))
        }, 0)
        this.timeNewDataA = setTimeout(() => {
          this.LineListTag = false
          this.rXCPieListTag = false
          this.radarListTag = false
          this.$nextTick(() => {
            this.LineListTag = true
            this.rXCPieListTag = true
            this.radarListTag = true
            // this.lineList = JSON.parse(JSON.stringify(this.tmpLineList))
          }, 0)
        }, timestamp * 3)
        this.timeNewDataB = setTimeout(() => {
          this.yclbPieListTag = false
          this.waterLineListTag = false
          this.$nextTick(() => {
            this.yclbPieListTag = true
            this.waterLineListTag = true
            // this.waterLineList = JSON.parse(JSON.stringify(this.tmpWaterLineList))
          }, 0)
        }, timestamp * 6)
        this.timeNewDataC = setTimeout(() => {
          this.typePieListTag = false
          this.horizontalObjTag = false
          this.$nextTick(() => {
            this.typePieListTag = true
            this.horizontalObjTag = true
          }, 0)
        }, timestamp * 9)
      },
      /**
       * 定时获取数据
       * @author: whl
       * @createDate: 2019/6/4
       * @return {Object}
       */
      dataFresh () {
        clearInterval(this.timeNewData)
        this.timeNewData = null
        this.timeNewData1 = setTimeout(() => {
          this.valueUpdate()
        }, 8000)
        this.timeNewData = setInterval(() => {
          this.valueUpdate()
        }, 50000)
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .statics-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    /*年份总览*/
    .export-btn{
       position: absolute;
       z-index: 102;
       top: 50px;
       right: 330px;
       padding: 6px 15px;
       color: #fff;
       font-size: 15px;
       cursor: pointer;
     }
    .export-btn::before{
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      background-color: #2d9371;
      transform: skewX(-20deg);
    }
    .export-btn:hover{
      opacity: .9;
    }
    .device-yc{
      left: 10px;
      top: 380px;
      width: 355px;
      height: 364px;
      .block-title{
        margin-top: -10px;
        margin-bottom: 10px;
      }
    }
    .year-view {
      left: 10px;
      top: 100px;
      width: 355px;

      .sel {
        text-align: left;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .select-range{
        margin-bottom: -20px;
        padding-left: 10px;
        .el-input__inner {
          background-color: #00141a;
          border: 1px solid #00141a;
          font-size: 16px;
          color: #00f17d;
          height: 35px;
          line-height: 35px;
        }
        .el-form-item__label{
          color: #fff !important;
          font-size: 16px;
        }
      }
      .new-select {
        width: 98px;

        .el-input__inner {
          background-color: #00141a;
          border: 1px solid #00141a;
          font-size: 16px;
          color: #00f17d;
          height: 35px;
          line-height: 35px;
        }

        .el-input__icon {
          line-height: 35px;
        }
      }

      .ex-span {
        font-size: 18px;
        color: #00f17d;
        margin-left: 5px;
      }

      .ex-count {
        margin-left: 10px;
        font-size: 30px;
        color: #fff;
      }
    }

    /*处置情况*/
    .eachSt{
      color: #08a91d;
    }
    .most-more {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #0a8b9c;
      cursor: pointer;
      z-index: 998;
    }
    .disposal1 {
      position: relative;
      margin: 45px 0 15px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .most-more{
        top: -28px;
      }
      &-item {
        background-color: #05375d;
        flex: 1;
        padding: 15px 10px;
        margin: 0 2px;

        p {
          font-size: 15px;
          color: #0aaade;
        }

        p:last-child {
          font-size: 25px;
          color: #fff;
          padding-top: 5px;
        }
      }
    }

    /*个类型的异常统计*/

    .yc-class {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: -10px;
      padding: 20px 10px 0;
      .most-more{
        top: 0;
      }
      &-ring{
        margin: 0 0 10px;
        &-name{
          color: #0aaade;
          font-size: 14px;
          padding: 10px 0 5px;
        }
        &-diff{
          display: inline-block;
          background: #001d33;
          padding: 2px 5px;
          min-width: 90px;
          color: #0186b6;
          font-size: 13px;
          border-radius: 10px;
          .zheng-num{
            color: #fcff00;
          }
          .fu-num{
            color: #12ff00;
          }
        }
      }
      &-item {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        background: #032138;
        width: 45%;
        margin: 2.5% 2.5% 11px;
        padding: 15px 0;
        height: 116px;

        p {
          width: 100%;
          color: #0aaade;
          font-size: 15px;
        }

        p:first-child {
          font-size: 25px;
          color: #fff;
        }

        p:last-child {
          margin-top: -5px;
        }
      }

      &-item:last-child {
        background-color: rgba(3, 33, 56, .6) !important;
      }
    }

    /*监管设备统计-原耗能统计*/

    .energy-count {
      left: 10px;
      top: 755px;
      width: 355px;
      height: 306px;
      position: relative;
      .most-more{
        top: 15px;
        right: 18px;
      }

      .energy-totals {
        position: absolute;
        left: 49%;
        top: 60%;
        transform: translate(-50%, -50%);
      }

      .energy-w {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin: 20px 0 -20px;

        &-item {
          width: 45%;
          margin: 0 2.5% 5%;
          height: 105px;
          padding: 10px 20px;
          background: #032138;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          text-align: left;

          p {
            color: #0aaade;
            width: 100%;
          }

          p:first-child {
            color: #fff;
            font-size: 25px;
            margin-bottom: -15px;

            span:last-child {
              /*padding-left: 2px;*/
              color: #5f696f;
              font-size: 16px;
            }
          }
        }

        &-item:nth-child(2), &-item:nth-child(4) {
          text-align: right !important;
        }
      }
    }

    /*月度异常趋势统计*/

    .distric1 {
      left: 378px;
      top: 100px;
      width: 1156px;
    }

    /*食材类别消费统计*/

    .foodType2 {
      left: 378px;
      top: 425px;
      width: 660px;
      height: 320px;
      display: flex;

      .block-title2 {
        position: absolute;
        width: 110px;
        height: 50px;
        left: 50%;
        top: 50%;
        margin-top: -25px;
        margin-left: -55px;
      }
      .el-carousel__container{
        height: 260px !important;
      }
    }

    .monthEc {
      .block-title2 {
        position: absolute;
        width: 110px;
        height: 50px;
        left: 40%;
        top: 50%;
        margin-top: -25px;
        margin-left: -55px;
        color: #00c0ff;
        font-size: 14px;

        span {
          color: #fff;
          font-size: 25px;
        }
      }
    }

    .legend-ul2 {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      li {
        width: 50%;
        display: flex;
        justify-content: flex-start;
        align-items: baseline;

        .li-l {
          text-align: left;
          margin-right: 8px;

          .color-block {
            display: block;
            background-color: #fff;
            width: 20px;
            height: 14px;
            border-radius: 2px;
          }
        }

        .li-r {
          /*margin-bottom: 5px;*/
          text-align: left;

          .legend-name {
            display: block;
            color: #0aaade;
            font-size: 14px;

            .legend-per {
              color: #00c0ff;
              font-size: 18px;

              span {
                font-size: 14px;
              }
            }
          }

          .legend-money {
            display: block;
            font-size: 18px;
            color: #fff;

            span {
              font-size: 14px;
              color: #5f696f;
            }
          }
        }
      }
    }

    .legend-uls {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -16px;
      flex: 1.5;
      align-items: center;

      .legend-uls-p{
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        line-height: 1;
      }
      li {
        width: 33.3%;
        margin-bottom: 15px;
        /*padding-right: 15px;*/
        text-align: left;

        .color-block2 {
          display: inline-block;
          background-color: #fff;
          width: 20px;
          height: 11px;
          border-radius: 2px;
          margin-right: 10px;
        }

        .legend-name2 {
          color: #0aaade;
          font-size: 14px;
          margin-top: 5px;
        }

        .legend-per2 {
          color: #00a3ff;
          font-size: 25px;

          span {
            font-size: 18px;
          }
        }
      }
    }

    /*异常食堂分布*/

    .foodOutType {
      left: 1050px;
      top: 425px;
      width: 485px;
      .el-tabs__item{
        color: #15ade9;
      }
      .el-tabs__item.is-active {
        color: #00f17d!important;
      }
    }

    /*监管设备资源统计*/

    .equipment {
      left: 378px;
      top: 755px;
      width: 660px;
      padding-bottom: 0;

      .el-carousel__container{
        height: 265px;
        z-index: 0;
      }
      .el-carousel{
        width: 100%;
      }
      .el-carousel__button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }
      .el-carousel__indicators--outside button{
        background-color: #000;
        opacity: 1;
      }
      .el-carousel__indicator.is-active button{
        background-color: #0a8b9c;
      }
      .el-carousel__indicator--horizontal{
        padding: 6px 4px;
      }
      .el-carousel__indicators--outside{
        margin-top: -23px;
      }

      &-cont {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        padding: 0 5px 5px;

        &-item {
          width: 18%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          margin: 14px 1% 0;
          background: #032138;
          height: 66px;
          color: #0aaade;
          font-size: 15px;

          p {
            width: 100%;
          }

          p:first-child {
            color: #fff;
            font-size: 18px;
            margin: 2px 0 -10px;
          }
        }
      }
    }

    /*各食堂人员分布情况*/

    .staff {
      left: 1050px;
      top: 755px;
      width: 485px;
      position: absolute;
      .pic-bar{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 245px;
        color: #00c0ff;
        font-size: 15px;
        &-item{
          padding: 10px 20px;
          &-num{
            font-size: 25px;
            color: #fff;
            margin-top: -15px;
            a{
              padding-right: 20px;
            }
            span{
              color: #5f696f;
              font-size: 13px;
            }
          }
          .names{
            margin-top: 5px;
          }
        }
      }
      &-more{
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: #0a8b9c;
        font-size: 14px;
        cursor: pointer;
      }
      &-detail{
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background: rgba(0,48,84,1);
      }
    }

    /*全年耗电、耗水趋势*/

    .eleWater {
      left: 378px;
      top: 755px;
      width: 1160px;
      display: flex;

      &-item {
        width: 50%;
      }
    }

    /*月度异常趋势*/

    .monthEc {
      left: 1550px;
      top: 100px;
      width: 350px;
    }

    /*食品出库月度趋势*/

    .monthFood {
      left: 1550px;
      top: 425px;
      width: 350px;
    }

    /*食堂资源统计*/

    .sourceCount {
      left: 1550px;
      top: 755px;
      width: 350px;
      min-height: 306px;
      .gender{
        display: flex;
        justify-content: space-between;
        &-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          &:first-child{
            p:first-child{
              color: #ff6f6f;
            }
          }
          p{
            margin-left: -25px;
            padding-bottom: 5px;
            color: #fff;
            font-size: 15px;
            text-align: left;
            &:nth-child(2){
              color: #00c0ff;
            }
            &:first-child{
              color: #21edff;
            }
            &:last-child{
              padding-bottom: 0;
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/nStatistics.vue